import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import axios from '../../../_services/api/axios';
import withErrorHandler from '../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../_store/actions/index';
import styles from "../../molecules/ScrollTable/ScrollTable.scss"
import { getTranslate } from 'react-localize-redux';
import {toastr} from 'react-redux-toastr'
import ReactTooltip from 'react-tooltip'

import { NotFoundPage, Spacer, Text, PageTemplate, Input, Button, Radio, Header, Hint, InfoText, PageTitle, GreyBox, DonutChart, Flex, ActionsNav, Icon, FlexColumn, BoxTitle, Confirm } from 'components'
import EditJobModal from './EditJobModal';
import ExportJobModal from './ExportJobModal';
import DetailedCalculationModal from './DetailedCalculationModal';

import { secondsFormatter } from '../../../_helpers/DateTime.js';

class JobPage extends Component {
	state = {
		jobToEdit: false,
		jobToDelete: false,
		jobToExport: false,
		jobToDetailedCalculation: false,
        gradiantOverlay: false,
        shownCalculation: {
        	Id: false,
        	efficiency: 0,
        	name: "",
        	heads: 0,
        	total_production_time: 0,
        	potential_total_production_time: 0,
        	production_time_per_piece: 0,
        	potential_production_time_per_piece: 0,
        	total_production_cost: 0,
        	potential_total_production_cost: 0,
        	production_cost_per_piece: 0,
        	potential_production_cost_per_piece: 0
        }
	}


	componentDidMount() {
		this.onFetchJobDetailHandler();
	}
	componentWillUnmount() {
		this.props.onCalculatorJobFetchReset();
		this.props.onCalculatorJobCalculationsFetchReset();
		this.props.onCalculatorJobDeleteReset();
		this.props.onCalculatorJobChangeActiveReset();
		this.props.onCalculatorJobMessageReset();
		this.props.onCalculatorJobRecalculateReset();
	}
	componentDidUpdate = (prevProps, prevState, snapshot) => {
		if(!this.state.jobToEdit && this.props.match.path === '/jobs/:id/edit') {
			this.setState({
				jobToEdit: true,
				jobToDelete: false,
				jobToExport: false,
				jobToDetailedCalculation: false
			});
		}
		else if(this.state.jobToEdit && this.props.match.path !== '/jobs/:id/edit') {
			this.setState({
				jobToEdit: false
			});
		}
		else if(!this.state.jobToExport && this.props.match.path === '/jobs/:id/export') {
			this.setState({
				jobToEdit: false,
				jobToDelete: false,
				jobToExport: true,
				jobToDetailedCalculation: false
			});
		}
		else if(this.state.jobToExport && this.props.match.path !== '/jobs/:id/export') {
			this.setState({
				jobToExport: false
			});
		}
		if(!prevProps.calculatorJob.calculations.fetched && this.props.calculatorJob.calculations.fetched) {

			this.setState(prevState => ({
                shownCalculation: this.props.calculatorJob.calculations.details.filter(calculation => calculation.active)[0]
            }));
		}
		if(!prevProps.calculatorJob.job.changed_used && this.props.calculatorJob.job.changed_used) {
			this.onFetchJobDetailHandler();
			this.props.onCalculatorJobChangeActiveReset();					
		}
		if(!prevProps.calculatorJob.job.recalculated && this.props.calculatorJob.job.recalculated) {
			this.onFetchJobDetailHandler();
			this.props.onCalculatorJobRecalculateReset();					
		}
		if(!prevProps.calculatorJob.job.message !== this.props.calculatorJob.job.message && this.props.calculatorJob.job.message) {
			toastr[this.props.calculatorJob.job.message.type](this.props.translate('jobpage.'+this.props.calculatorJob.job.message.type+'.'+this.props.calculatorJob.job.message.key+'.title'), this.props.translate('jobpage.'+this.props.calculatorJob.job.message.type+'.'+this.props.calculatorJob.job.message.key+'.text')); 
			this.props.onCalculatorJobMessageReset();
		}
		if(this.state.jobToEdit) {
			ReactTooltip.rebuild();
		}
	}

	onFetchJobDetailHandler = () => {
		this.props.onCalculatorJobFetch(this.props.match.params.id);
		this.props.onCalculatorJobCalculationsFetch(this.props.match.params.id);
	}
   	onDeleteCancelHandler = ( event ) => {
   		event.preventDefault();
   		this.setState({jobToDelete : false})
   	}
   	onDeleteConfirmHandler = ( event ) => {
   		event.preventDefault();
   		this.setState({jobToDelete : true})
   	}
   	onDeleteHandler = ( event ) => {
   		event.preventDefault();
   		this.props.onCalculatorJobDelete(this.props.calculatorJob.job.details.Id);
   	}
 	setAsUsedHandler = (event, inputIdentifier) => {
        let value = event.target.value;
        this.props.onCalculatorJobChangeActive(this.props.calculatorJob.job.details.Id, {calculation_id : value});
 	}
 	showCalculationHandler = ( id, event )  => {
 		this.setState(prevState => ({
            shownCalculation: this.props.calculatorJob.calculations.details.filter(calculation => calculation.Id === id)[0]
        }));
 	}
 	recalculateHandler = (event) => {
   		event.preventDefault();
 		this.props.onCalculatorJobRecalculate(this.props.calculatorJob.job.details.Id);
 	}
 	onDetailedCalculationHandler = (event) => {
 		event.preventDefault();
 		this.setState({
			jobToEdit: false,
			jobToDelete: false,
			jobToExport: false,
			jobToDetailedCalculation: true
		});
 	}
 	onDetailedCalculationClosedHandler = () => {
 		this.setState({
			jobToDetailedCalculation: false
		}); 		
 	}

	wheel(e) {
		if(e.deltaX === 0){
		    if (e.deltaY >= 0) {
		    	document.getElementById('scroll').scrollLeft += 40;
		    } else if (e.deltaY >= 0){
		    	document.getElementById('scroll').scrollLeft -= 40;
		    } else {
		    	document.getElementById('scroll').scrollLeft -= 40;
		    }



		    let tmpState = false
		    if(document.getElementById('scroll').scrollLeft == 0){
		    	tmpState = false;
		    }else{
		    	tmpState = true;
		    }

			this.setState(prevState => ({
	            gradiantOverlay: tmpState
	        }));

		    e.preventDefault();
		}
	}

	round(number, length) {

	  let factor = Math.pow(10, length);
	  let rounded = Math.round(number * factor) / factor
	  return rounded
	}
	render() {
		console.log(this.state.shownCalculation);
		if(this.props.calculatorJob.job.deleted) {
    		return (
    			<Redirect to="/jobs" />
    		)
		}
		else {
			if(this.props.calculatorJob.job.error && this.props.calculatorJob.job.error.length) {
	            if(this.props.calculatorJob.job.error[0].key === 'NOT_EXIST') {
	            	return (<NotFoundPage/>)
	            }
	        }
	        var jobModal = "";
			if(this.state.jobToEdit) {
				jobModal = (<EditJobModal onUpdated={this.onFetchJobDetailHandler}/>);
			}
			else if(this.state.jobToExport) {
				jobModal = (<ExportJobModal/>);
			}
			else if(this.state.jobToDetailedCalculation) {
				jobModal = (<DetailedCalculationModal onCloseModal={this.onDetailedCalculationClosedHandler} jobId={this.props.calculatorJob.job.details.Id} calculationId={this.state.shownCalculation.Id}/>);
			}
			let confirm = "";
			if(this.state.jobToDelete) {
				confirm = (
					  <Confirm onCancel={this.onDeleteCancelHandler} onConfirm={this.onDeleteHandler} title={this.props.translate('jobpage.delete.label')} text={this.props.translate('jobpage.delete.text')}/>
				)
			}
			let changedMachineSetup = "";
			if('global_settings' in this.props.calculatorJob.job.details && !this.props.calculatorJob.job.details.global_settings) {
				changedMachineSetup = (
					<Hint type="error" text={this.props.translate('jobpage.machinesetup.text')} buttonText={this.props.translate('jobpage.machinesetup.recalculate')} buttonClicked={this.recalculateHandler} noPrint={true}/>
				)
			}
			return (
				<PageTemplate header={<Header />} appendComponent={confirm ? confirm : jobModal}>
					<Flex>
						<PageTitle ellipsis="60%">{this.props.calculatorJob.job.details.name}</PageTitle>
						<FlexColumn width="0px" align="right">
							<ActionsNav>
								<Link to={'/jobs/'+ this.props.calculatorJob.job.details.Id +'/edit'}><Icon type="image" content="edit" size="16px" /></Link>
								<Link to={'/jobs/'+ this.props.calculatorJob.job.details.Id +'/export'}><Icon type="image" content="export" size="16px" /></Link>
								<a onClick={this.onDeleteConfirmHandler}><Icon type="image" content="delete" size="16px"/></a>
							</ActionsNav>
						</FlexColumn>
					</Flex>
					{changedMachineSetup}
					<GreyBox type="fullWidth" noPrint={true}>
						<Flex break="m" align="start">
							<FlexColumn width="190px">
								<div className={styles.isHiddenDesktop}>
									<BoxTitle>{this.state.shownCalculation.name}</BoxTitle>
									<Text color="#2F2D2F" fontCut="light">{this.state.shownCalculation.heads} {this.state.shownCalculation.heads > 1 ? this.props.translate('global.machine.head.multiple') : this.props.translate('global.machine.head.one')}</Text>
									<Spacer height="28px" />
								</div>
								<DonutChart size="164" font="large" value={this.state.shownCalculation.efficiency} valuelabel={this.props.translate('jobpage.calculation.efficiency')} strokewidth="22"  />
							</FlexColumn>
							<FlexColumn width="447px">
								<Spacer height="5px" />
								<div className={styles.isHiddenMobile}>
								
									<BoxTitle>{this.state.shownCalculation.name}</BoxTitle>
									<Text color="#2F2D2F" fontCut="light">{this.state.shownCalculation.heads} {this.state.shownCalculation.heads > 1 ? this.props.translate('global.machine.head.multiple') : this.props.translate('global.machine.head.one')}</Text>
									<Spacer height="28px" />
								</div>
								<Flex break="xs" align="start">
									<FlexColumn width="auto">
										<Flex align="start">
											<FlexColumn width="48px">
												<Icon type="image" content="time" size="30px" display="inline" />
											</FlexColumn>
											<FlexColumn width="139px">
												<div className={styles.small}>
													{secondsFormatter(this.state.shownCalculation.total_production_time,true)}
													<Text color="#AAAAAA" size="small">
														{this.props.translate('jobpage.calculation.potential',{value: secondsFormatter(this.state.shownCalculation.potential_total_production_time,true)})}
													</Text>
													<Spacer height="5px" />
													{this.props.translate('jobpage.calculation.per_piece',{value: secondsFormatter(this.state.shownCalculation.production_time_per_piece,true)})}								
													<Text color="#AAAAAA" size="small">
													{this.props.translate('jobpage.calculation.potential',{value: secondsFormatter(this.state.shownCalculation.potential_production_time_per_piece,true)})}
													</Text>
												</div>
											</FlexColumn>
										</Flex>
										<Spacer height="20px" />
									</FlexColumn>
									<FlexColumn width="auto">
										<Flex align="start">
											<FlexColumn width="48px">
												<Icon type="image" content="cost" size="30px" display="inline" />
											</FlexColumn>
											<FlexColumn width="139px">
												<div className={styles.small}>
													{this.round(this.state.shownCalculation.total_production_cost,2)}
													<Text color="#AAAAAA" size="small">{this.props.translate('jobpage.calculation.potential',{value: this.round(this.state.shownCalculation.potential_total_production_cost,2) != 0 ? this.round(this.state.shownCalculation.potential_total_production_cost,2) : '-'})}
													</Text>
													<Spacer height="5px" />
													{this.props.translate('jobpage.calculation.per_piece',{value: this.round(this.state.shownCalculation.production_cost_per_piece,2)})}
													<Text color="#AAAAAA" size="small">
													{this.props.translate('jobpage.calculation.potential',{value: this.round(this.state.shownCalculation.potential_production_cost_per_piece,2) != 0 ? this.round(this.state.shownCalculation.potential_production_cost_per_piece,2) : '-'})}
													</Text>
												</div>
											</FlexColumn>
										</Flex>
									</FlexColumn>
								</Flex>
							</FlexColumn>
							<FlexColumn width="264px" valign="bottom" noPrint={true}>
								<Spacer height="20px" />
								<Button width="264px" onClick={this.onDetailedCalculationHandler} value={this.props.translate('jobpage.calculation.detailed_calculation')} theme="dark" />
								<Spacer height="20px" />
							</FlexColumn>
						</Flex>
					</GreyBox>
					<div className={styles.shadow}>
						<div className={styles.parent} id="scroll" onWheel = {(e) => this.wheel(e)}>
					      	<div className={styles.wrapper}>
				                <div className={styles.jobList}>

				                	<div className={styles.jobListRow + ' ' + styles.noPrint}>
										<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.titleColumn + ' ' + (this.state.gradiantOverlay ? styles.shadow : ' ')}>
											<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.jobdetailtable.machine')} data-event='click' data-for='GlobalTooltip' data-place="top">
											<Icon type="image" content="hint" size="13px" display="inline" />
											</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
											<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.jobdetailtable.efficiency')} data-event='click' data-for='GlobalTooltip' data-place="top">
											<Icon type="image" content="hint" size="13px" display="inline" />
											</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
											<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.jobdetailtable.modular')} data-event='click' data-for='GlobalTooltip' data-place="top">
											<Icon type="image" content="hint" size="13px" display="inline" />
											</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
											<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.jobdetailtable.actual_heads')} data-event='click' data-for='GlobalTooltip' data-place="top">
											<Icon type="image" content="hint" size="13px" display="inline" />
											</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
											<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.jobdetailtable.actual_cost')} data-event='click' data-for='GlobalTooltip' data-place="top">
											<Icon type="image" content="hint" size="13px" display="inline" />
											</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
											<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.jobdetailtable.actual_time')} data-event='click' data-for='GlobalTooltip' data-place="top">
											<Icon type="image" content="hint" size="13px" display="inline" />
											</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
											<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.jobdetailtable.potential_cost')} data-event='click' data-for='GlobalTooltip' data-place="top">
											<Icon type="image" content="hint" size="13px" display="inline" />
											</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.isRight}>
											<div className={styles.iconWithHint} data-tip={this.props.translate('global.help.jobdetailtable.potential_time')} data-event='click' data-for='GlobalTooltip' data-place="top">
											<Icon type="image" content="hint" size="13px" display="inline" />
											</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellHelp + ' ' + styles.jobListCellLineLeft}>
										
										</div>
				                	</div>
									<div className={styles.jobListRow + ' ' + styles.spacer}>
										<div className={styles.jobListCell}></div>
										<div className={styles.jobListCell}></div>
										<div className={styles.jobListCell}></div>
										<div className={styles.jobListCell}></div>
										<div className={styles.jobListCell}></div>
										<div className={styles.jobListCell}></div>
										<div className={styles.jobListCell}></div>
										<div className={styles.jobListCell}></div>
										<div className={styles.jobListCell + ' ' + styles.noPrint}></div>
									</div>

				                	<div className={styles.jobListRow}>
										<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.titleColumn + ' ' + (this.state.gradiantOverlay ? styles.shadow : ' ')}>
											{this.props.translate('global.job.table.header_machine')}
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
											{this.props.translate('global.job.table.header_efficiency')}
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
											{this.props.translate('global.job.table.header_modular')}
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
											{this.props.translate('global.job.table.header_heads')}
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
											<Icon type="image" content="cost" size="13px" display="inline" />
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
											<Icon type="image" content="time" size="13px" display="inline" />
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
											<Icon type="image" content="cost" size="13px" display="inline" />
											<div className={styles.subLine}>{this.props.translate('global.job.table.header_potential')}</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.isRight}>
											<Icon type="image" content="time" size="13px" display="inline" />
											<div className={styles.subLine}>{this.props.translate('global.job.table.header_potential')}</div>
										</div>
				                		<div className={styles.jobListCell + ' ' + styles.jobListCellTitle + ' ' + styles.jobListCellLineLeft + ' ' + styles.noPrint}>
										

										</div>
				                	</div>

									{this.props.calculatorJob.calculations.details.map((calculation, index) =>
									<div 	key={index} 
											className={styles.jobListRow + ' ' + (this.state.shownCalculation.Id === calculation.Id ? styles.jobListRowActive : '')} 
											onClick={this.showCalculationHandler.bind(this, calculation.Id)}>
										<div className={styles.jobListCell + ' ' + styles.titleColumn + ' ' + (this.state.gradiantOverlay ? styles.shadow : ' ')}>
											<div className={styles.textWrap}>{calculation.name}
											{calculation.recommended ? <div className={styles.recommended}>{this.props.translate('global.job.table.recommendation')}</div> : ''}
											</div>
										</div>
										<div className={styles.jobListCell + ' ' + styles.isRight + ' ' + styles.firstCellMover}>
											{Math.round(calculation.efficiency * Math.pow(10, 0)) / Math.pow(10, 0)}%
										</div>
										<div className={styles.jobListCell + ' ' + styles.isRight}>
											{!calculation.multihead ? (<Icon type="image" content="yes" size="10px" display="inline" />) : (<Icon type="image" content="no" size="10px"  display="inline" />)}
										</div>
										<div className={styles.jobListCell + ' ' + styles.isRight}>
											{calculation.heads}
										</div>
										<div className={styles.jobListCell + ' ' + styles.isRight}>
											{this.round(calculation.total_production_cost, 2)}
										</div>
										<div className={styles.jobListCell + ' ' + styles.isRight}>
					
											{secondsFormatter(calculation.total_production_time)}
										</div>
										<div className={calculation.performance_cost === 'worse' ? [styles.jobListCell, styles.isRight, styles.tendencyDown].join(' ') : calculation.performance_cost === 'same' ? [styles.jobListCell, styles.isRight, styles.tendencyEven].join(' ') : [styles.jobListCell, styles.isRight, styles.jobPotentialCosts, styles.tendencyUp].join(' ')}>
											{this.round(calculation.potential_total_production_cost, 2) != 0 ? this.round(calculation.potential_total_production_cost, 2) : '-'}
										</div>
										<div className={calculation.performance_time === 'worse' ? [styles.jobListCell, styles.isRight, styles.tendencyDown].join(' ') : calculation.performance_time === 'same' ? [styles.jobListCell, styles.isRight, styles.tendencyEven].join(' ') : [styles.jobListCell, styles.isRight, styles.jobPotentialTime, styles.tendencyUp].join(' ')}>
											{secondsFormatter(calculation.potential_total_production_time)}
										</div>
										<div className={styles.jobListCell + ' ' + styles.jobListCellLineLeft + ' ' + styles.noPrint}>
											<Radio checked={calculation.active} value={calculation.Id} label={calculation.active ? this.props.translate('global.job.table.used') : this.props.translate('global.job.table.set_as_used')} identifier="set_as_used" changed={this.setAsUsedHandler}/>
										</div>
				                	</div>
									)}

						        </div>
		              	 	</div>
		              	</div>
		             </div>
					<InfoText icon={<Icon type="image" content="info" size="17px"/>} text={this.props.translate('jobpage.info.list')}/>
				</PageTemplate>
			)
		}
	}
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        calculatorJob: state.calculatorJob,
        fetching: state.fetching,
        translate: getTranslate(state.locale),
        settingsCompany: state.calculatorSettingsCompany
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCalculatorJobFetch: (id) => dispatch(actionCreators.calculatorJobFetch(id)),
        onCalculatorJobFetchReset: () => dispatch(actionCreators.calculatorJobFetchReset()),
        onCalculatorJobMessageReset: () => dispatch(actionCreators.calculatorJobMessageReset()),
        onCalculatorJobCalculationsFetch: (id) => dispatch(actionCreators.calculatorJobCalculationsFetch(id)),
        onCalculatorJobCalculationsFetchReset: () => dispatch(actionCreators.calculatorJobCalculationsFetchReset()),
        onCalculatorJobDeleteReset: () => dispatch(actionCreators.calculatorJobDeleteReset()),
        onCalculatorJobDelete: (id) => dispatch(actionCreators.calculatorJobDelete(id)),
        onCalculatorJobChangeActive: (id, formData) => dispatch(actionCreators.calculatorJobChangeActive(id, formData)),
        onCalculatorJobChangeActiveReset: () => dispatch(actionCreators.calculatorJobChangeActiveReset()),
        onCalculatorJobRecalculate: (id) => dispatch(actionCreators.calculatorJobRecalculate (id)),
        onCalculatorJobRecalculateReset: () => dispatch(actionCreators.calculatorJobRecalculateReset())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(JobPage, axios));


// WEBPACK FOOTER //
// ./src/components/pages/JobPage/index.js